export default [
    {
      title: 'menu.Offers',
      icon: 'ListIcon',
      tagVariant: 'light-danger',
      route:'offers'
    },
  ]
  